import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export const Objections = () => {
  const faqs = [{
    q: 'No soy creativa, ¿igual puedo hacerlo?',
    a: "Sí. El método es un paso a paso exacto. No necesitás 'inspiración', solo seguir las instrucciones y las plantillas que te damos."
  }, {
    q: 'No sé vender ni me gusta insistir.',
    a: 'Por eso enseñamos a vender por Instagram de forma magnética. Tu contenido atrae personas, sin perseguir a nadie.'
  }, {
    q: 'No tengo experiencia haciendo velas.',
    a: 'El 90% de las alumnas empezó desde cero. Vas a aprender desde derretir la cera hasta empacar como marca premium.'
  }, {
    q: 'Ya compré cursos antes y no los terminé.',
    a: 'Este es 100% práctico. Cada módulo termina con una acción concreta para que veas resultados rápidos y te mantengas motivada.'
  }, {
    q: 'No tengo mucho tiempo libre.',
    a: 'Podés ver las clases a tu ritmo. Con 1 o 2 horas los fines de semana, alcanza para empezar.'
  }];
  return <section className="py-24 bg-nude/30" data-id="element-164">
      <div className="max-w-3xl mx-auto px-6" data-id="element-165">
        <FadeIn className="text-center mb-16" data-id="element-166">
          <span className="inline-block text-sm font-semibold tracking-widest uppercase text-accent-rose-deep mb-4" data-id="element-167">
            Antes de empezar
          </span>
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-168">Resolvemos tus dudas</h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-169">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} delay={i * 0.08} data-id="element-170" />)}
        </div>
      </div>
    </section>;
};
const FAQItem = ({
  question,
  answer,
  delay
}: {
  question: string;
  answer: string;
  delay: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={delay} direction="up" data-id="element-171">
      <div className="bg-white rounded-2xl border border-beige overflow-hidden" data-id="element-172">
        <button onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-173">
          <span className="font-bold text-base md:text-lg pr-4 text-text-dark" data-id="element-174">
            {question}
          </span>
          <ChevronDown className={`w-5 h-5 text-accent-rose-deep transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-175" />
        </button>
        <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-176">
          <p className="text-text-brown/80 leading-relaxed" data-id="element-177">{answer}</p>
        </div>
      </div>
    </FadeIn>;
};